import * as React from "react";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-xml";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/mode-text";
import "ace-builds/src-noconflict/theme-monokai";

interface ImportSimResponseFilesProps {
    outputTO: string;
}

export function ImportSimResponseFiles({ outputTO }: ImportSimResponseFilesProps) {
    const actions = React.useMemo(() => {
        if (!outputTO) return [];
        try {
            return JSON.parse(outputTO).flatMap((item: any) =>
                (item.actions || [])
                    .filter((a: any) => a.respondFileAction?.base64Content)
                    .map((a: any) => a.respondFileAction)
            );
        } catch { return []; }
    }, [outputTO]);

    const [selectedIndex, setSelectedIndex] = React.useState(0);

    if (actions.length === 0) return <p>No response files available.</p>;

    const selected = actions[selectedIndex];
    const mode = selected.fileName?.endsWith(".xml") ? "xml" : selected.fileName?.endsWith(".json") ? "json" : "text";
    let content = "";
    try { content = atob(selected.base64Content); } catch { content = "Unable to decode."; }

    return <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        {actions.length > 1 && <div style={{ display: "flex", gap: 4, padding: 4, flexWrap: "wrap" }}>
            {actions.map((a: any, i: number) =>
                <button key={i}
                        onClick={() =>
                            setSelectedIndex(i)}
                        style={{
                            padding: "5px 10px",
                            border: "none",
                            borderRadius: 4,
                            cursor: "pointer",
                        }}>
                    {a.fileName}</button>)}
            </div>
        }
        <div style={{ padding: "4px 8px", fontSize: 13, color: "#666" }}>
            <strong>{selected.fileName}</strong>{selected.path && <span> — {selected.path}</span>}
        </div>
        <AceEditor
            mode={mode}
            theme="monokai"
            value={content}
            readOnly={true}
            width="100%"
            height="100vh"
            fontSize={13}
            showPrintMargin={false}
            highlightActiveLine={false}
            setOptions={{ useWorker: false, showLineNumbers: true, tabSize: 2 }}
        />
    </div>;
}